import codes from "../../errorCodes/Stocks"

export default function stocksErrorHandler(code: string) {
  switch (code) {
    case codes.SqlAdapterWriteErr:
      return "errors.PBSTOSqlAdapterWrite"
    case codes.SqlAdapterReadErr:
      return "errors.PBSTOSqlAdapterRead"
    case codes.SqlAdapterRecordCountErr:
      return "errors.PBSTOSqlAdapterRecordCount"
    case codes.SqlAdapterArchiveExpired:
      return "errors.PBSTOSqlAdapterArchiveExpired"
    case codes.InvalidAuth:
      return "errors.PBSTOInvalidAuth"
    case codes.ItemNotFound:
      return "errors.PBSTOItemNotFound"
    case codes.ProductNotFound:
      return "errors.PBSTOProductNotFound"
    case codes.InvalidJson:
      return "errors.PBSTOInvalidJson"
    case codes.InvalidUuid:
      return "errors.PBSTOInvalidUuid"
    case codes.ResourceConflict:
      return "errors.PBSTOResourceConflict"
    case codes.NoBodyRequired:
      return "errors.PBSTONoBodyRequired"
    case codes.PaginationInvalidPage:
      return "errors.PBSTOPaginationInvalidPage"
    case codes.CodeNotUnique:
      return "errors.PBSTOCodeNotUnique"
    case codes.CodeExistsInBatch:
      return "errors.PBSTOCodeExistsInBatch"
    case codes.ItemExpiryDateInPast:
      return "errors.PBSTOItemExpiryDateInPast"
    case codes.NoPoOnSingleUseItem:
      return "errors.PBSTONoPoOnSingleUseItem"
    case codes.ExpiryDateStatusError:
      return "errors.PBSTOExpiryDateStatusError"
    case codes.ItemStatusNotClosed:
      return "errors.PBSTOItemStatusNotClosed"
    case codes.ItemWrongStatusForUpdate:
      return "errors.PBSTOItemWrongStatusForUpdate"
    case codes.ItemWrongStatusForArchive:
      return "errors.PBSTOItemWrongStatusForArchive"
    case codes.ItemCannotBeClosedDirectly:
      return "errors.PBSTOItemCannotBeClosedDirectly"
    case codes.ItemMultiUseWrongStatus:
      return "errors.PBSTOItemMultiUseWrongStatus"
    case codes.CSVItemsMustBeSameProduct:
      return "errors.PBSTOCSVItemsMustBeSameProduct"
    case codes.CSVItemsMustBeSingleUse:
      return "errors.PBSTOCSVItemsMustBeSingleUse"
    case codes.CSVItemsUploadLimit:
      return "errors.PBSTOCSVItemsUploadLimit"
    case codes.InvalidType:
      return "errors.PBSTOInvalidType"
    case codes.InvalidUsage:
      return "errors.PBSTOInvalidUsage"
    case codes.InvalidAttributes:
      return "errors.PBSTOInvalidAttributes"
    case codes.InvalidStatus:
      return "errors.PBSTOInvalidStatus"
    case codes.InvalidCode:
      return "errors.PBSTOInvalidCode"
    case codes.InvalidPin:
      return "errors.PBSTOInvalidPin"
    case codes.InvalidExpiry:
      return "errors.PBSTOInvalidExpiry"
    case codes.InvalidPoNumber:
      return "errors.PBSTOInvalidPoNumber"
    case codes.InvalidRequestNoData:
      return "errors.PBSTOInvalidRequestNoData"
    case codes.NotANumber:
      return "errors.PBSTONotANumber"
    case codes.NotNonEmptyString:
      return "errors.PBSTONotNonEmptyString"
    case codes.NotNonEmptyNoSpecialChar:
      return "errors.PBSTONotNonEmptyNoSpecialChar"
    case codes.InvalidDate:
      return "errors.PBSTOInvalidDate"
    case codes.FileUrlNotUnique:
      return "errors.PBSTOFileUrlNotUnique"
    case codes.FileUrlExistsInBatch:
      return "errors.PBSTOFileUrlExistsInBatch"
    case codes.SingleUseItemEmptyPONumber:
      return "errors.PBSTOSingleUseItemEmptyPONumber"
    case codes.CodeAlreadyExists:
      return "errors.PBSTOCodeAlreadyExists"
    case codes.OpenItemsNotFoundForProduct:
      return "errors.PBSTOOpenItemsNotFoundForProduct"
    case codes.ArchivedItemsNotFoundForProduct:
      return "errors.PBSTOArchivedItemsNotFoundForProduct"
    default:
      return ""
  }
}
